import type { ReactNode } from 'react'

interface Props {
  eyebrow: string
  title: string
  body?: string
  children?: ReactNode
}

export default function EmptyState({ eyebrow, title, body, children }: Props) {
  return (
    <div
      style={{
        border: '0.5px dashed rgba(244,242,242,0.12)',
        borderRadius: 10,
        padding: '64px 32px',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          fontFamily: "'Helvetica Neue', 'HelveticaNeue', Helvetica, 'Inter', Arial, sans-serif",
          fontSize: 10,
          letterSpacing: '0.18em',
          textTransform: 'uppercase',
          color: '#C2E530',
          marginBottom: 16,
        }}
      >
        {eyebrow}
      </div>
      <div
        style={{
          fontFamily: "'Lora', Georgia, serif",
          fontStyle: 'italic',
          fontSize: 18,
          color: '#F4F2F2',
          marginBottom: body ? 8 : 0,
          lineHeight: 1.4,
        }}
      >
        {title}
      </div>
      {body && (
        <div
          style={{
            fontFamily: "'Lora', Georgia, serif",
            fontSize: 14,
            color: 'rgba(198,196,185,0.6)',
            maxWidth: 380,
            margin: '0 auto',
            lineHeight: 1.55,
          }}
        >
          {body}
        </div>
      )}
      {children && <div style={{ marginTop: 22 }}>{children}</div>}
    </div>
  )
}
